import React, { Component } from "react";
import axios from "axios";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { materialsValidator } from "../utils/materialsValidator";
import {
    Typography,
    Button,
    Col,
    Drawer,
    Form,
    Input,
    Space,
    Select,
    DatePicker,
    message,
} from "antd";
const initialState = {
    name: "",
    appointment_types: [],
    isGlobal: false,
    mandatory: false,
    type: null,
    material_options: []
};
class MaterialDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            materialTypesOptions: [
                {
                    label: "Obligatorio",
                    value: "mandatory"
                },
                {
                    label: "Opcional",
                    value: "optional"
                },
                {
                    label: "Extra",
                    value: "extra"
                }
            ],
            appointmentTypeOptions: [],
            valueTypesOptions: [
                {
                    label: "Selección única",
                    value: "single",
                },
                {
                    label: "Selección múltiple",
                    value: "multiple",
                },
                {
                    label: "Verdadero/Falso",
                    value: "boolean",
                },
                {
                    label: "Texto",
                    value: "text",
                },
                {
                    label: "Número",
                    value: "number",
                },
            ],
            material: props.material || initialState,
            formErrors: {},
        };
        this.formRef = React.createRef();
        this.handleCloseForm = this.handleCloseForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.validationRefetch = this.validationRefetch.bind(this);
        this.laodAppointmentsCall = this.laodAppointmentsCall.bind(this);
        this.formSetInitialState = this.formSetInitialState.bind(this);
    }
    componentDidMount() {
        this.laodAppointmentsCall();
    }
    componentDidUpdate(prevProps) {
        if (this.props.material !== null && !this.props.isNewMaterial && (prevProps.material !== this.props.material || this.state.material === initialState)) {
            const { material } = this.props;
            this.setState({
                material: {
                    uuid: material.uuid,
                    name: material.name,
                    appointment_types: material.appointment_types ? material.appointment_types.map((appointment_type) => (appointment_type.id)) : null,
                    material_type: material.isGlobal ? {
                        label: "Extra",
                        value: "extra"
                    } : material.mandatory ? {
                        label: "Obligatorio",
                        value: "mandatory"
                    } : {
                        label: "Opcional",
                        value: "optional"
                    },
                    type: material.type,
                    material_options: material.material_options ? material.material_options.map((material) => ({
                        appointment_type: material.appointment_type.id,
                        material_option: material.name,
                    })) : null
                }
            });
            this.formRef.current.setFieldsValue({
                name: material.name,
                appointment_types: material.appointment_types ? material.appointment_types.map((appointment_type) => (appointment_type.id)) : null,
                material_type: material.isGlobal ? {
                    label: "Extra",
                    value: "extra"
                } : material.mandatory ? {
                    label: "Obligatorio",
                    value: "mandatory"
                } : {
                    label: "Opcional",
                    value: "optional"
                },
                type: material.type,
                material_options: material.material_options ? material.material_options.map((material) => ({
                    appointment_type: material.appointment_type.id,
                    material_option: material.name,
                })) : null
            });
        }
        if (prevProps.isNewMaterial !== this.props.isNewMaterial && this.props.isNewMaterial) {
            this.formSetInitialState();
        }
    }
    componentWillUnmount() {
        console.log("desmontando")

    }
    laodAppointmentsCall = async () => {
        try {
            const appointmentsCall = await axios.get('https://backoffice.nadu.xyz/api/appointment-types');
            if (appointmentsCall && appointmentsCall.data) {
                let formattedData = appointmentsCall.data.data.map((appointment) => ({ label: appointment.attributes.name, value: appointment.id }));
                this.setState({ appointmentTypeOptions: formattedData })
            }
        } catch (error) {
            console.error('Error al obtener contenido:', error);
            message.error('Error al obtener los materiales.');
        }
    };
    handleCloseForm = () => {
        this.formSetInitialState(),
            this.props.handleOpenDrawerModal(false);
    };
    formSetInitialState = () => {
        this.formRef.current.setFieldsValue({
            name: "",
            appointment_types: null,
            material_type: null,
            type: null,
            material_options: null
        });
        this.setState({ formErrors: {} })
        this.setState({ material: initialState })
    }
    handleSubmit = async () => {
        let createData = this.formRef.current.getFieldsValue()
        try {
            const createCall = await axios.post('https://backoffice.nadu.xyz/api/material-type/create', {
                name: createData.name,
                type: createData.type,
                appointment_types: createData.appointment_types,
                isGlobal: createData.material_type === "extra",
                mandatory: createData.material_type === "mandatory",
                material_options: createData.material_options ? createData.material_options.map((material_option) => ({
                    name: material_option.material_option,
                    appointment_type: material_option.appointment_type,
                })) : undefined
            });
            if (createCall.data && createCall.data.ok) {
                this.props.loadMaterialsCall();
                this.handleCloseForm();
                message.success('Se ha creado el material');
            } else {
                message.error('Error al crear el material');
            }
        } catch (error) {
            message.error('Error al crear el material');
            console.error('Error al crear el material:', error);
        }
    }
    handleEdit = async () => {
        let editData = this.formRef.current.getFieldsValue()
        try {
            const editCall = await axios.put(`https://backoffice.nadu.xyz/api/material-type/edit/${this.state.material.uuid}`, {
                name: editData.name,
                type: editData.type,
                appointment_types: editData.appointment_types,
                isGlobal: editData.material_type === "extra",
                mandatory: editData.material_type === "mandatory",
                material_options: editData.material_options ? editData.material_options.map((material_option) => ({
                    name: material_option.material_option,
                    appointment_type: material_option.appointment_type,
                })) : undefined
            });
            if (editCall.data && editCall.data.ok) {
                this.props.loadMaterialsCall();
                message.success('Se ha editado el material');
                this.handleCloseForm();
            }
        } catch (error) {
            message.error('Error al editar el material');
            console.error('Error al editar el material:', error);
        }
    }
    validationRefetch = () => {
        if (this.formRef.current) {
            let fields = this.formRef.current.getFieldsValue();
            const errors = materialsValidator(fields);
            this.setState({ formErrors: errors });
        }
    }
    render() {
        const { material } = this.state;
        const { isNewMaterial } = this.props;
        return (
            <Drawer
                title={
                    isNewMaterial
                        ? "Crear material"
                        : "Editar material"
                }
                width={720}
                onClose={() => this.handleCloseForm()}
                open={this.props.showDrawerModal}
            >
                <Form ref={this.formRef} layout="vertical" hideRequiredMark>
                    <Col span={24}>
                        <Form.Item
                            name="name"
                            label="Nombre"
                            hasFeedback
                            validateStatus={this.state.formErrors.name ? "error" : null}
                            help={
                                this.state.formErrors.name ? this.state.formErrors.name : null
                            }
                        >
                            <Input
                                name="name"
                                value={material.name}
                                style={{ width: "100%" }}
                                placeholder="Ingresar el nombre"
                                onChange={(event) => {
                                    const { name, value } = event.target;
                                    this.setState(prevState => ({
                                        material: {
                                            ...prevState.material,
                                            [name]: value
                                        }
                                    }), () => this.validationRefetch());
                                }}
                            />

                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="appointment_types"
                            label="Tipos de cita"
                            hasFeedback
                            validateStatus={this.state.formErrors.appointment_types ? "error" : ""}
                            help={
                                this.state.formErrors.appointment_types ? this.state.formErrors.appointment_types : ""
                            }
                        >
                            <Select
                                name="appointment_types"
                                placeholder="Seleccionar tipos de cita"
                                allowClear
                                mode="multiple"
                                value={material.appointment_types}
                                options={this.state.appointmentTypeOptions}
                                onChange={(value) => {
                                    this.setState(prevState => ({
                                        material: {
                                            ...prevState.material,
                                            appointment_types: value
                                        }
                                    }), () => {
                                        let fields = this.formRef.current.getFieldsValue();
                                        if (fields.material_options && fields.appointment_types) {
                                            let filteredMaterialOptions = fields.material_options.filter(option =>
                                                !option.appointment_type || fields.appointment_types.includes(option.appointment_type)
                                            );
                                            this.formRef.current.setFieldsValue({ material_options: filteredMaterialOptions });
                                        }
                                        this.validationRefetch();
                                    });
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="material_type"
                            label="Tipo de material"
                            hasFeedback
                            validateStatus={this.state.formErrors.material_type ? "error" : ""}
                            help={
                                this.state.formErrors.material_type ? this.state.formErrors.material_type : ""
                            }
                        >
                            <Select
                                name="material_type"
                                placeholder="Seleccionar tipo de material"
                                allowClear
                                options={this.state.materialTypesOptions}
                                onChange={() => this.validationRefetch()}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="type"
                            label="Tipo de valor"
                            hasFeedback
                            validateStatus={this.state.formErrors.type ? "error" : ""}
                            help={
                                this.state.formErrors.type ? this.state.formErrors.type : ""
                            }
                        >
                            <Select
                                name="type"
                                placeholder="Seleccionar tipo de valor"
                                allowClear
                                value={material.type}
                                options={this.state.valueTypesOptions}
                                onChange={(value) => {
                                    this.setState(prevState => ({
                                        material: {
                                            ...prevState.material,
                                            type: value
                                        }
                                    }), () => this.validationRefetch())
                                }}
                            />
                        </Form.Item>
                    </Col>
                    {(material.appointment_types.length > 0 && material.type && (material.type === "single" || material.type === "multiple")) &&
                        <Col span={24}>
                            <Form.List name="material_options">
                                {(fields, { add, remove }) => (
                                    <div>
                                        <div style={{ marginBottom: "8px" }}>Opciones de material</div>
                                        <Form.Item>
                                            <Button
                                                type="dashed"
                                                onClick={() => add()}
                                                style={{ width: '100%' }}
                                                icon={<PlusOutlined />}
                                            >
                                                Añadir opción de material
                                            </Button>
                                        </Form.Item>
                                        {fields.map(({ key, name, ...restField }) => (
                                            <div key={key} style={{ display: 'flex', width: "100%" }}>
                                                <Form.Item
                                                    {...restField}
                                                    style={{ flex: 1, marginRight: 8, width: "100%" }}
                                                    name={[name, 'material_option']}
                                                    validateTrigger={['onChange', 'onBlur']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            whitespace: true,
                                                            message: "Por favor ingrese una opción de material o elimine este campo.",
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder="Nombre de opción de material"
                                                        style={{ width: '100%' }}
                                                        onChange={() => this.validationRefetch()}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    {...restField}
                                                    style={{ flex: 1, width: "100%" }}
                                                    name={[name, 'appointment_type']}
                                                    validateTrigger={['onChange', 'onBlur']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Por favor seleccione un tipo de cita.",
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        placeholder="Tipo de cita"
                                                        style={{ width: '100%' }}
                                                        onChange={() => this.validationRefetch()}
                                                    >
                                                        {this.state.appointmentTypeOptions
                                                            .filter(option => material.appointment_types.includes(option.value))
                                                            .map(option => (
                                                                <Select.Option key={option.value} value={option.value}>
                                                                    {option.label}
                                                                </Select.Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                                {fields.length > 0 ? (
                                                    <MinusCircleOutlined
                                                        onClick={() => remove(name)}
                                                        style={{ marginLeft: 8, marginRight: 8, marginBottom: 24 }}
                                                    />
                                                ) : null}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </Form.List>
                        </Col>
                    }
                    <Space style={{ paddingTop: "8px" }}>
                        <Button onClick={() => this.handleCloseForm()}>
                            Cancelar
                        </Button>
                        <Button
                            onClick={() =>
                                isNewMaterial
                                    ? this.handleSubmit()
                                    : this.handleEdit()
                            }
                            type="primary"
                            disabled={Object.keys(this.state.formErrors).length > 0}
                        >
                            {isNewMaterial ? "Crear material" : "Editar material"}
                        </Button>
                    </Space>
                </Form>
            </Drawer>
        );
    }
}

export default MaterialDrawer;



// WEBPACK FOOTER //
// ./src/views/Configurator/components/MaterialModalDrawer.jsx